import React from 'react';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  Title
} from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(ArcElement, Tooltip, Legend, Title, ChartDataLabels);

export default function GraficoVolComTipo({ dados }) {
  const labels = dados ? dados.map(d => d.comp) : [];
  const valores = dados ? dados.map(d => d.qtd) : [];

  const data = {
    labels,
    datasets: [
      {
        label: 'Volume (Litros)',
        data: valores,
        backgroundColor: [
          'rgb(17, 141, 255)',   // blue-900
          'rgb(224, 68, 167)',   // blue-700
          'rgb(107, 0, 123)',  // blue-500
          'rgb(230, 108, 55)', // blue-300
          'rgba(248, 144, 7, 0.8)', // gray-500
          'rgb(18, 35, 158)', // gray-400
        ],
        borderColor: [
          '#ffffff',
        ],
        borderWidth: 2,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'right',
        labels: { boxWidth: 12 }
      },
      title: {
        display: true,
        text: 'Quantidade Compartimento',
        font: { size: 16 },
        padding: { bottom: 20 }
      },
      datalabels: {
        color: '#fff',
        font: { weight: 'bold', size: 10 },
        formatter: (value, ctx) => {
          let sum = 0;
          let dataArr = ctx.chart.data.datasets[0].data;
          dataArr.map(data => { sum += Number(data); });
          let percentage = (value * 100 / sum).toFixed(1) + "%";
          if(value === 0 || sum === 0) return '';
          return percentage;
        },
      }
    },
  };

  return (
    <div className="bg-white p-4 shadow-sm rounded-lg h-80 flex flex-col items-center justify-center">
      {dados && dados.length > 0 ? (
        <Doughnut data={data} options={options} />
      ) : (
        <p className="text-gray-400">Sem dados para exibir - Quantidade Compartimento</p>
      )}
    </div>
  );
}
